/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/base/index';

import 'resources/less/themes/base/widgets/pricing_calculator.less';
import 'resources/less/themes/base/widgets/products_tabs.less';
import 'resources/less/themes/base/widgets/shipping_calendar.less';
import 'resources/less/themes/base/widgets/davinci_viewer.less';
import 'resources/less/themes/base/widgets/shopper_approved.less';
import 'resources/less/themes/base/widgets/standalone/reviews.less';
import 'resources/less/themes/base/widgets/standalone/mailing_service.less';
import 'resources/less/themes/base/widgets/standalone/progress_bar.less';
import 'APP_THEME/_common/main_banner/index.less';
import 'APP_THEME/_common/tabs_bar/index.less';
import 'APP_THEME/_common/start_page/start/old.less';

import RoyalSlider from 'APP_THEME/_common/royal_slider/index';
const royalSlider = new RoyalSlider('.royalSlider');

import StartPageView from 'assets/js/modules/pages/start/view/startPageView';
import StartPageInit from 'APP_THEME/_common/start_page/start/index';
import 'APP_THEME/_common/selectboxit/index';

$(function() {
    const startPageInit = new StartPageInit('#product-details-tab', {
        showDvsDesigner: false,
        showUploadInfo: true,
        handleBannerClicks: false,
        StartPageView
    });
});
